import { connect } from 'react-redux';
import Products from './Products';
import { mapStateToProps, mapDispatchToProps } from './Products.state';

export default connect(mapStateToProps, mapDispatchToProps)(Products);
